import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import LogisticRouteTagsDt from '@/services/dataTransferModules/logisticRouteTagsDt'

export default function useLogisticRouteTags(params = {}) {
	const logisticRouteTagsDt = new LogisticRouteTagsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingField: {
			name: '',
		},
		fieldsToPatch: [
			'name',
		],
	}

	const {
		loadEntityFlags: flags,

		entities: logisticRouteTags,
		getEntities: getLogisticRouteTags,

		createEntity: createLogisticRouteTag,

		entity: logisticRouteTag,
		getEntity: getLogisticRouteTag,

		patchEntity: patchLogisticRouteTag,
		updateEntity: putLogisticRouteTag,

		deleteEntity: deleteLogisticRouteTag,
	} = useBlProviders(
		logisticRouteTagsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error loading logistic routes tags'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		logisticRouteTags,
		logisticRouteTag,
		defaults,

		getLogisticRouteTags,
		getLogisticRouteTag,
		createLogisticRouteTag,
		putLogisticRouteTag,
		patchLogisticRouteTag,
		deleteLogisticRouteTag,
	}
}
